import { Fragment, useState, useRef } from 'react';

import ViewProfile from './ViewProfile';

import close from '../../assets/img/closeIcon.svg';
import classes from '../ShortlistComponent/AddProperty.module.css';
import ModalLayout from '../ShortlistComponent/ModalLayout';

const ProviderProfile = ({ hideModal, currentProvider }) => {
  return (
    <ModalLayout hideModal={hideModal}>
      <h2>Provider Profile</h2>
      <img src={close} className={classes.close} onClick={hideModal} />
      <div className={classes['provider__title']}>
        <div>
          Provider Name: <b>{currentProvider?.providerName}</b>
        </div>
      </div>
      <div className={classes['pdfpage']}>
        {currentProvider?.pdfPath && <ViewProfile pdfURL={currentProvider?.pdfPath} />}
      </div>
    </ModalLayout>
  );
};

export default ProviderProfile;
